export const SET_BODYPART = 'SET_BODYPART';
export const SET_BODYPARTS = 'SET_BODYPARTS';
export const SET_BODYPARTS_QUERY_PARAMS = 'SET_BODYPARTS_QUERY_PARAMS';
export const SET_BODYPARTS_SET_IS_FETCHING = 'SET_BODYPARTS_SET_IS_FETCHING';

export const SET_DICTBODYPART = 'SET_DICTBODYPART';
export const SET_DICTBODYPARTS = 'SET_DICTBODYPARTS';
export const SET_DICTBODYPARTS_QUERY_PARAMS = 'SET_DICTBODYPARTS_QUERY_PARAMS';
export const SET_DICTBODYPARTS_SET_IS_FETCHING = 'SET_DICTBODYPARTS_SET_IS_FETCHING';
